import React from 'react';
import jQuery from 'jquery';
import SortUtils from './utils/SortUtils.js';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './KnsConfigurator.styl';
import Table from "./ui/features/Table.jsx";


/**
 * Конфигуратор подбора аксессуаров к пластиковым КНС
 */
class KnsConfigurator extends Configurator {
	constructor(props) {
		super(props);

		this.state = jQuery.extend({}, this.state, {

			mode: 'cable', // Режим подбора аксессуаров к кабель-каналу (cable) / трубе (pipe)

			itemList: [], // Подобранные аксессуары
			specList: [], // Спецификация оборудования

			pickUpDisabled: false,

			// Подобранный кабель-канал / труба
			pickedUpItem: null,

			// Фильтр Огнестойкий
			filterOkl: false,

			// Фильтры кабель-каналов
			filterCableSeries: '',
			filterCableSize: null,
			filterCableColor: null,
			filterCablePrimerType: 'accessory',
			filterCablePrimerEuiType: null,
			filterCablePrimerWorkplaceCoating: null,
			filterCablePrimerWorkplaceModules: null,

			// Фильтры труб
			filterPipeType: null,
			filterPipeDiameter: null,
			filterPipeColor: null,
			filterPipeIp: null

		});


		this.onModeChange = this.onModeChange.bind(this);
		this.onOklChange = this.onOklChange.bind(this);

		this.onCableSeriesChange = this.onCableSeriesChange.bind(this);
		this.onCableSizeChange = this.onCableSizeChange.bind(this);
		this.onCableColorChange = this.onCableColorChange.bind(this);
		this.onCablePrimerTypeChange = this.onCablePrimerTypeChange.bind(this);
		this.onCablePrimerEuiTypeChange = this.onCablePrimerEuiTypeChange.bind(this);
		this.onCablePrimerWorkplaceCoatingChange = this.onCablePrimerWorkplaceCoatingChange.bind(this);
		this.onCablePrimerWorkplaceModulesChange = this.onCablePrimerWorkplaceModulesChange.bind(this);

		this.onPipeTypeChange = this.onPipeTypeChange.bind(this);
		this.onPipeDiameterChange = this.onPipeDiameterChange.bind(this);
		this.onPipeColorChange = this.onPipeColorChange.bind(this);
		this.onPipeIpChange = this.onPipeIpChange.bind(this);
		this.onBtnPickUp = this.onBtnPickUp.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		this.onChangeQuantity = this.onChangeQuantity.bind(this);
		this.addBasket = this.addBasket.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.findKKOrPip = this.findKKOrPip.bind(this);
		this.onDownloadInstruction = this.onDownloadInstruction.bind(this);


	}

	getType() {
		return 'kns';
	}

	getCustomStyles() {
		return styles;
	}

	getCableOrPipeList(itemList, prop) {

		let list = [];

		for (let i = 0; i < itemList.length; i++) {
			const item = itemList[i];
			if (item.type !== prop) {
				continue;
			}

			list.push(item);
		}

		return list;
	}

	// Цвета трубы, реально существующие для конкретной пары тип+диаметр
	// diameter из БД приходит числом, а из <select> — строкой, поэтому сравниваем через String()
	getPipeColorList(type, diameter) {
		const pipeColorList = [];

		this.db.kns_pipe.forEach(item => {
			if (item.type === type && String(item.diameter) === String(diameter) && pipeColorList.indexOf(item.color) < 0) {
				pipeColorList.push(item.color);
			}
		});

		return pipeColorList;
	}


	onAfterDbLoad() {
		super.onAfterDbLoad();

		// При загрузке в фильтры подставляются значения ЭЛЕКОР белый , однако в таблицу выводятся все значения кабеля без фильтра
		let cableSeries = 'elecor_white';
		let cblList = this.getCableOrPipeList(this.db.list, 'cable')
		let filterCableSizes = Helper.cableGetFilterValuesBySeries(cblList, cableSeries, 'size');

		SortUtils.sortSize(filterCableSizes);

		this.setState({
			filterCableSeries: cableSeries,
			filterCableSize: filterCableSizes[0],
			filterCableColor: null,
			filterCablePrimerType: 'accessory',
			filterCablePrimerEuiType: 'Силовые',
			filterCablePrimerWorkplaceCoating: 'бетон и технические полы',
			filterCablePrimerWorkplaceModules: '12',

			itemList: cblList,
			pickUpDisabled: false
		});

		// Установка начальных фильтров для труб TODO
		const pipeTypeList = [];
		const pipeDiameterList = [];
		this.db.kns_pipe.forEach(item => {
			if (pipeTypeList.indexOf(item.type) < 0) {
				pipeTypeList.push(item.type);
			}

			if (item.type === pipeTypeList[0] && pipeDiameterList.indexOf(item.diameter) < 0) {
				pipeDiameterList.push(item.diameter);
			}
		});

		Helper.sortDiameter(pipeDiameterList);

		const pipeColorList = this.getPipeColorList(pipeTypeList[0], pipeDiameterList[0]);

		this.setState({
			filterPipeType: pipeTypeList[0],
			filterPipeDiameter: pipeDiameterList[0],
			filterPipeColor: pipeColorList[0],
			filterPipeIp: 'IP40',
		});
	}

	onModeChange(event) {
		if (!event.target.checked) {
			return;
		}
		let itemlist = this.getCableOrPipeList(this.db.list, event.target.value)

		this.setState({
			mode: event.target.value,
			item: null,
			itemList: itemlist,
			pickUpDisabled: false,
			pickedUpItem: null
		});
	}

	onOklChange(event) {

		this.setState({
			filterOkl: event.target.checked
		});

		this.onPipeTypeChange(event.target.checked ? {target: {value: 'Труба гофрированная ПВХ'}} : {target: {value: 'Труба гофрированная ПНД'}});
	}

	onCableSeriesChange(event) {
		this.changeCableSeries(event.target.value);
	}

	onCableSizeChange(event) {

		this.setState({
			filterCableSize: event.target.value,
			pickUpDisabled: false
		});
	}

	onCableColorChange(event) {

		this.setState({
			filterCableColor: event.target.value,
			pickUpDisabled: false
		});
	}

	onCablePrimerTypeChange(event) {
		let euiType = 'accessory'
		if(event.target.checked){
			euiType = 'eui'
		}
		this.setState({
			filterCablePrimerType: euiType,
			itemList: [],
			pickUpDisabled: false
		});
	}

	onCablePrimerEuiTypeChange(event) {
		this.setState({
			filterCablePrimerEuiType: event.target.value,
			pickUpDisabled: false
		});
	}

	onCablePrimerWorkplaceCoatingChange(event) {
		this.setState({
			filterCablePrimerWorkplaceCoating: event.target.value,
			pickUpDisabled: false
		});
	}

	onCablePrimerWorkplaceModulesChange(event) {
		this.setState({
			filterCablePrimerWorkplaceModules: event.target.value,
			pickUpDisabled: false
		});
	}

	onPipeTypeChange(event) {

		const pipeDiameterList = [];

		this.db.kns_pipe.forEach(item => {
			if (item.type === event.target.value && pipeDiameterList.indexOf(item.diameter) < 0) {
				pipeDiameterList.push(item.diameter);
			}
		});

		Helper.sortDiameter(pipeDiameterList);

		const pipeColorList = this.getPipeColorList(event.target.value, pipeDiameterList[0]);

		this.setState({
			filterPipeType: event.target.value,
			filterPipeDiameter: pipeDiameterList[0],
			filterPipeColor: pipeColorList[0],
			pickUpDisabled: false
		});
	}

	onPipeDiameterChange(event) {
		const filterPipeDiameter = event.target.value;
		const pipeColorList = this.getPipeColorList(this.state.filterPipeType, filterPipeDiameter);

		// Сохраняем текущий цвет, если он существует и для нового диаметра, иначе берём первый доступный
		const filterPipeColor = pipeColorList.indexOf(this.state.filterPipeColor) >= 0
			? this.state.filterPipeColor
			: pipeColorList[0];

		this.setState({
			filterPipeDiameter,
			filterPipeColor,
			pickUpDisabled: false
		});
	}

	onPipeColorChange(event) {
		this.setState({
			filterPipeColor: event.target.value,
			pickUpDisabled: false
		});
	}

	onPipeIpChange(event) {
		this.setState({
			filterPipeIp: event.target.value,
			pickUpDisabled: false
		});
	}

	changeCableSeries(cableSeries) {
		//Если выбрана продукция Ecoline, подбираем в базе денных те же товары что и для "Elcore" но оставляем то же название
		let ecoline_key_word = '';
		let elecore_key_word = '';
		if (cableSeries === 'ecoline_white') {
			ecoline_key_word = 'ecoline_white';
			elecore_key_word = 'elecor_white';
		} else if (cableSeries === 'ecoline_color') {
			ecoline_key_word = 'ecoline_color';
			elecore_key_word = 'elecor_color';
		}

		let filterCableSizes = Helper.cableGetFilterValuesBySeries(this.db.list, cableSeries === ecoline_key_word ? elecore_key_word : cableSeries, 'size');
		let filterCableColors = Helper.cableGetFilterValuesBySeries(this.db.list, cableSeries === ecoline_key_word ? elecore_key_word : cableSeries, 'color');


		SortUtils.sortSize(filterCableSizes);

		let itemlist = this.getCableOrPipeList(this.db.list, 'cable')

		this.setState({
			filterCableSeries: cableSeries,
			filterCableSize: filterCableSizes[0],
			filterCableColor: filterCableColors.length > 0 ? filterCableColors[0] : null,
			filterCablePrimerType: 'accessory',
			filterCablePrimerEuiType: 'Силовые',
			filterCablePrimerWorkplaceCoating: 'бетон и технические полы',
			filterCablePrimerWorkplaceModules: '12',

			item: null,
			itemList: itemlist,

			pickUpDisabled: false,
			pickedUpItem: null
		});
	}


	getList(state) {
		const pipeAccessoryArticles = [];
		let pickedUpItem = null;

		// Поиск трубы по параметрам
		if (state.mode === 'pipe') {
			for (let i = 0; i < this.db.kns_pipe.length; i++) {
				const pipe = this.db.kns_pipe[i];

				if (String(pipe.diameter) !== String(state.filterPipeDiameter)) {
					continue;
				}

				if (pipe.type !== state.filterPipeType) {
					continue;
				}

				if (pipe.color !== state.filterPipeColor) {
					continue;
				}

				pickedUpItem = pipe;

				break;
			}

			if (pickedUpItem) {
				this.db.kns_pipe2accessory.forEach(p2a => {
					if (pickedUpItem.article === p2a.pipe_article) {
						pipeAccessoryArticles.push(p2a.accessory_article);
					}
				});
			}
		} else {
			for (let i = 0; i < this.db.kns_kk.length; i++) {
				const kk = this.db.kns_kk[i];

				if (kk.series !== state.filterCableSeries) {
					continue;
				}


				if (kk.size !== state.filterCableSize) {
					continue;
				}

				if (state.filterCableColor && kk.color !== state.filterCableColor) {
					continue;
				}


				pickedUpItem = kk;

				break;
			}
		}

		const itemList = this.db.list.filter(item => {

			const isMetKrep = item.article.indexOf('CMAT') === 0; // Металлический крепеж

			if (state.mode !== item.type) {
				return false;
			}

			if (state.filterOkl && !item.okl && !isMetKrep) {
				return false;
			}

			if (!state.filterOkl && isMetKrep) {
				return false;
			}

			if (state.mode === 'cable') // По кабель-каналу
			{

				let filterCableSeries;

				if (state.filterCableSeries === 'ecoline_white') {
					filterCableSeries = 'elecor_white';
				} else if (state.filterCableSeries === 'ecoline_color') {
					filterCableSeries = 'elecor_color';
				} else {
					filterCableSeries = state.filterCableSeries;
				}

				if (item.cable_series !== filterCableSeries && filterCableSeries !== 'primer') {

					return false;
				}

				if (state.filterCablePrimerType === 'eui' && ['CKK10D-U-1-K01', 'CKK10D-U-1-K32'].indexOf(item.article) < 0) {
					if (item.cable_series !== 'primer_eui') {

						return false;
					}

					if (item.eui_type !== this.state.filterCablePrimerEuiType) {

						return false;
					}
				} else if (state.filterCableSeries === 'primer' && item.cable_series !== state.filterCableSeries) {
					return false;
				}

				if (state.filterCableSeries === 'elecor_color' && item.color !== state.filterCableColor) {
					return false;
				}

				if (item.size !== null && item.size !== 'all' && item.size !== state.filterCableSize) {
					return false;
				}

				if (state.filterCableSeries === 'elecor_color' && item.color !== state.filterCableColor) {
					return false;
				}

				if (state.filterCableSeries === 'primer_workplace') {
					if (item.workplace_coating !== state.filterCablePrimerWorkplaceCoating) {
						return false;
					}

					if (item.workplace_modules !== state.filterCablePrimerWorkplaceModules) {
						if (!(item.workplace_modules === '12 / 16' && (state.filterCablePrimerWorkplaceModules === '12' || state.filterCablePrimerWorkplaceModules === '16'))) {
							return false;
						}
					}
				}

			} else if (state.mode === 'pipe') // По трубам
			{
				// При наличии признака "Огнестойкий" в трубах ПВХ должен появляться металлический крепеж (CMAT)
				if (item.article[0] === 'U' || isMetKrep) {
					if (!item.diameter) {
						return false;
					}

					if (item.diameter.split(',').indexOf(String(state.filterPipeDiameter)) === -1) {
						return false;
					}
				} else {
					if (pipeAccessoryArticles.indexOf(item.article) === -1) {
						return false;
					}
				}

				if (item.ip !== 'all' && item.ip !== state.filterPipeIp) {
					return false;
				}
			}

			return true;
		});

		return {
			itemList: itemList,
			pickedUpItem
		};
	}

	/**
	 * Подобрать
	 */
	onBtnPickUp() {
		const pickUpList = this.getList(this.state);

		this.setState({
			itemList: pickUpList.itemList,
			pickedUpItem: pickUpList.pickedUpItem,
			pickUpDisabled: true
		});
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.state.specList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}


	onListItemCheck(item) {
		super.onListItemCheck(item.article)
	}


	onDelete(item) {
		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article)
			}
		},()=>{
			this.doAddToCart(this.state.specList)
		})

	}

	// добавить элемент в корзину
	addBasket(item) {

		let kkOrPipe = this.findKKOrPip(item, this.state.filterCableSeries);

		this.setState(prevState => {
			const specList = [...prevState.specList]
			if (specList.some(i => i.article === item.article)) {
				specList.map(i => {
					if (i.article === item.article) {
						i.count = +i.count + 1
					}
					return i
				})
			} else {
				item.count = 1
				specList.push(item)
			}

			return {specList}
		}, () => {
			if (Object.keys(kkOrPipe).length !== 0
				&& !this.state.specList.filter(i => i.article === kkOrPipe.article).length
				&& (item.type === 'pipe' || item.type === 'cable')) {
				this.addBasket(kkOrPipe)
			}else {
				this.doAddToCart(this.state.specList)
			}
		})
	}

// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article) {
					i.count = value
				}
				return i
			})
			this.doAddToCart(newBasket)
			return {
				specList: newBasket
			}
		})
	}


	findKKOrPip(item, series) {

		let parrent = {}
		// Если выбран аксесуар кабель-канала подбираем ему кабель-канал
		if (item.type === 'cable') {
			this.db.kns_kk.forEach(kns => {
				if (kns.series === series && kns.size === item.size && item.color == null)
				{
					parrent = kns
				}else if(item.color !== null
				&& kns.series === series
					&& kns.size === item.size
					&& item.color === kns.color){
					parrent = kns
				}
			})
			//Если выбран аксесуар трубы, подбираем ему трубу
		} else if (item.type === 'pipe') {

			let boundArray =  this.db.kns_pipe2accessory.filter((i,index) =>(i.accessory_article === item.article))
			let pipeList = boundArray.map(i => {
				return this.db.kns_pipe[this.db.kns_pipe.findIndex(j => j.article === i.pipe_article)]
			})

			parrent = pipeList.filter(i =>(this.state.filterPipeColor === i.color))[0]

		}

		return parrent;
	}


	onDownloadInstruction() {
		window.location = `itkcfg.php?action=getFileZip&type=${this.getType()}&name=instruction&article=GRSH_SMART`;
	}


	render() {
		if (!this.db) {
			return <div className={styles.cfg}/>;
		}

		return (
			<div className={styles.cfg}>
				{/*Белый фон заголовка*/}
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>

				<div style={{margin: '0 auto', backgroundColor: '#fff', width: '100%', height: '80px'}}></div>
				<div className={styles.title}>Конфигуратор подбора аксессуаров к пластиковым КНС</div>

				{/* Подобрать аксессуар к Кабель-каналу */}
				<div className={styles.sectionTitle}>Подобрать аксесуар к:</div>

				<label className={styles.modeCableChk}><input type="checkbox" checked={this.state.mode === 'cable'}
																											onChange={this.onModeChange} value="cable"/> Кабель-каналу</label>

				{/* Подобрать аксессуар к Трубе */}
				<label className={styles.modePipeChk}><input type="checkbox" checked={this.state.mode === 'pipe'}
																										 onChange={this.onModeChange} value="pipe"/> Трубе</label>

				{/* Фильтры */}
				<FilterRouter app={this}/>

				<Button
					x="20"
					y="671"
					buttonStyle={styles.pdfBtn}
					buttonDisabledStyle={styles.pdfBtnDisabled}
					textStyle={styles.instBtnText}
					iconStyle={styles.pdfBtnIcon}
					text="Инструкция пользования конфигуратором"
					disabled={false}
					onClick={() => this.onDownloadInstruction(this.state.item)}
					key="instructionPdf"
				/>

				<Table
					title='Спецификация оборудования'
					type='Bucket'
					items={this.state.specList}
					styles={{width: '407px', height: '515px', top: "102px", left: '440px', fontSize: '12px', fontColor:'#37424a'}}
					onSelect={this.onListItemCheck}
					onDelete={this.onDelete}
					onChangeQuantity={this.onChangeQuantity}
				/>

				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.item ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item.article}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.item.article}</div>
							<div>{this.state.item.name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
				/>


				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '472px',
					left: '869px',
					backgroundColor: '#fff',
					width: '311px',
					height: '180px'
				}}></div>
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>
						{this.state.item.okl ? <div className={styles.descriptionOkl}>{this.state.item.okl}</div> : null}
						{this.state.item.description}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
						{this.state.item && this.state.item.okl ?
							<div className={styles.descriptionOkl}>{this.state.item.okl}</div> : null}
					</div>
				)}

				{/* Распечатать */}
				<Button x="440" y="671" buttonStyle={styles.printBtn} iconStyle={styles.printBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.printBtnDisabled}
								disabled={this.pickUpDisabled} text="Распечатать" onClick={this.onBtnPrintClick}/>

				{/* Сохранить в PDF */}
				<Button x="633" y="671" buttonStyle={styles.pdfBtn} iconStyle={styles.pdfBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pdfBtnDisabled}
								disabled={this.pickUpDisabled} text="Сохранить в PDF" onClick={this.onBtnPrintPdfClick}/>

				{/* Сохранить в Excel */}
				<Button x="826" y="671" buttonStyle={styles.excelBtn} iconStyle={styles.excelBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.excelBtnDisabled}
								disabled={this.pickUpDisabled} text="Сохранить в Excel" onClick={this.onBtnExcelClick}/>


				{/* Скачать базу Revit */}
				<a
					target="_blank"
					style={{
						width: '183px',
						height: '35px',
						left: '1019px',
						top: '671px',
						position: 'absolute',
						textDecoration: 'none',
						color: '#334647'
					}}
					href={'http://www.iek.ru/products/standard_solutions/download/kabel-kanaly-i-aksessuary-iek-dlya-revit.zip'}
				>
					<Button
						x="0"
						y="0"
						buttonStyle={styles.revitBtn}
						iconStyle={styles.revitBtnIcon}
						textStyle={styles.mainBtnTextCentered}
						buttonDisabledStyle={styles.revitBtnDisabled}
						disabled={this.pickUpDisabled}
						text="Скачать базу Revit"
					/>
				</a>

				{/* Сертификаты ОКЛ */}
				<a
					target="_blank"
					style={{
						width: '183px',
						height: '35px',
						left: '236px',
						top: '671px',
						position: 'absolute',
						textDecoration: 'none',
						color: '#334647'
					}}
					href={'https://www.iek.ru/promo/okl/'}
				>
					<Button
						x="0"
						y="0"
						buttonStyle={styles.oklBtn}
						iconStyle={styles.oklBtnIcon}
						textStyle={styles.mainBtnTextCentered}
						buttonDisabledStyle={styles.oklBtnDisabled}
						disabled={this.pickUpDisabled}
						text="Сертификаты ОКЛ"
					/>
				</a>

				{/* На основной сайт IEK */}
				<div style={{
					position: 'absolute',
					top: '723px',
					left: '623px',
					backgroundColor: '#37424a',
					width: '578px',
					height: '22px'
				}}></div>
				<a href={this.db.localization.homeLink[this.props.locale]} className={styles.homeLink}>На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					top: '723px',
					left: '20px',
					backgroundColor: '#fff',
					width: '603px',
					height: '22px'
				}}></div>

				<a style={{
					position: 'absolute',
					top: '726px',
					left: '344px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}}
				href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>{this.db.localization.techSupport[this.props.locale]}</span>
			</div>
		);
	}
}


class FilterRouter extends React.Component {
	render() {
		switch (this.props.app.state.mode) {
			case 'cable':
				return <FilterModeCable {...this.props} />;

			case 'pipe':
				return <FilterModePipe {...this.props} />;
		}

		return null;
	}
}


/**
 * Фильтр кабель-канал
 */
class FilterModeCable extends React.Component {
	render() {

		let filter = null;

		switch (this.props.app.state.filterCableSeries) {
			case 'elecor_white':
				filter = <FilterModeCableElecorWhite {...this.props} />;
				break;

			case 'elecor_color':
				filter = <FilterModeCableElecorColor {...this.props} />;
				break;

			case 'elecor_plintus':
				filter = <FilterModeCableElecorPlintus {...this.props} />;
				break;

			case 'ecoline_color':
				filter = <FilterModeCableEcolineColor {...this.props} />;
				break;

			case 'ecoline_white':
				filter = <FilterModeCableEcolineWhite {...this.props} />;
				break;

			case 'primer':
				filter = <FilterModeCablePrimer {...this.props} />;
				break;

			case 'primer_workplace':
				filter = <FilterModeCablePrimerWorkplace {...this.props} />;
				break;
		}

		return (
			<div>
				<label className={styles.cableSeriesOkl}><input type="checkbox" checked={this.props.app.state.filterOkl}
																												onChange={this.props.app.onOklChange}/> Наличие сертификата
					"Огнестойкий"</label>

				<span className={styles.cableSeriesLable}>Серия:</span>

				<select className={styles.series} value={this.props.app.state.filterCableSeries}
								onChange={this.props.app.onCableSeriesChange}>
					<option value="elecor_white">&laquo;ELECOR&raquo; белый</option>
					<option value="elecor_color">&laquo;ELECOR&raquo; цветной</option>
					<option value="elecor_plintus">&laquo;ELECOR&raquo; плинтусный</option>
					<option value="ecoline_white">&laquo;ECOLINE&raquo; белый</option>
					<option value="ecoline_color">&laquo;ECOLINE&raquo; цветной</option>
					<option value="primer">&laquo;PRIMER&raquo;</option>
					<option value="primer_workplace">Система организации рабочего места</option>
				</select>

				{filter}
			</div>
		);
	}
}


/**
 * ЭЛЕКОР белый
 */
class FilterModeCableElecorWhite extends React.Component {
	render() {

		const sizes = Helper.cableGetFilterValuesBySeries(this.props.app.db.list, 'elecor_white', 'size');

		SortUtils.sortSize(sizes);

		return (
			<div>

				<span className={styles.cableSizeLable}>Габариты:</span>

				<select className={styles.size} value={this.props.app.state.filterCableSize}
								onChange={this.props.app.onCableSizeChange}>
					{sizes.map(size => {
						return <option value={size} key={size}>{size}</option>
					})}
				</select>

				<span className={styles.cableSizeMmLable}>мм</span>

				<Button x="20" y="301" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="301" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.state.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '250px', top: "367px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ЭЛЕКОР цветной
 */
class FilterModeCableElecorColor extends React.Component {
	render() {

		const list = this.props.app.db.list.filter(item => {

			if (item.cable_series !== 'elecor_color') {
				return false;
			}

			if (item.color !== this.props.app.state.filterCableColor) {
				return false;
			}

			return true;
		});

		let sizes = Helper.cableGetFilterValuesBySeries(list, 'elecor_color', 'size');

		SortUtils.sortSize(sizes);

		return (
			<div>

				<span className={styles.cableSizeLable}>Цвет:</span>
				<select className={styles.size} value={this.props.app.state.filterCableColor}
								onChange={this.props.app.onCableColorChange}>
					<option value="сосна">Сосна</option>
					<option value="дуб">Дуб</option>
				</select>

				<span className={styles.cableSizeLable2}>Габариты:</span>
				<select className={styles.size2} value={this.props.app.state.filterCableSize}
								onChange={this.props.app.onCableSizeChange}>
					{sizes.map(size => {
						return <option value={size} key={size}>{size}</option>
					})}
				</select>
				<span className={styles.cableSizeMmLable2}>мм</span>

				<Button x="20" y="344" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="344" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '207px', top: "410px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ЭЛЕКОР плинтусный
 */
class FilterModeCableElecorPlintus extends React.Component {
	render() {
		return (
			<div>

				<Button x="20" y="258" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="258" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '291px', top: "324px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ЭКОЛАЙН Белый
 */
class FilterModeCableEcolineWhite extends React.Component {
	render() {

		//Для Эколайна и для Элекора подбираются одни и те же аксесуары
		const sizes = Helper.cableGetFilterValuesBySeries(this.props.app.db.list, 'elecor_white', 'size');

		SortUtils.sortSize(sizes);
		return (
			<div>

				<span className={styles.cableSizeLable}>Габариты:</span>

				<select className={styles.size} value={this.props.app.state.filterCableSize}
								onChange={this.props.app.onCableSizeChange}>
					{sizes.map(size => {
						return <option value={size} key={size}>{size}</option>
					})}
				</select>

				<span className={styles.cableSizeMmLable}>мм</span>

				<Button x="20" y="301" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="301" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксесуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '250px', top: "368px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					// onDoubleClick={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ЭКОЛАЙН цветной
 */
class FilterModeCableEcolineColor extends React.Component {
	render() {

		const list = this.props.app.db.list.filter(item => {

			if (item.cable_series !== 'elecor_color') {
				return false;
			}

			if (item.color !== this.props.app.state.filterCableColor) {
				return false;
			}

			return true;
		});

		const sizes = Helper.cableGetFilterValuesBySeries(list, 'elecor_color', 'size');

		SortUtils.sortSize(sizes);

		return (
			<div>

				<span className={styles.cableSizeLable}>Цвет:</span>
				<select className={styles.size} value={this.props.app.state.filterCableColor}
								onChange={this.props.app.onCableColorChange}>
					<option value="сосна">Сосна</option>
					<option value="дуб">Дуб</option>
				</select>

				<span className={styles.cableSizeLable2}>Габариты:</span>
				<select className={styles.size2} value={this.props.app.state.filterCableSize}
								onChange={this.props.app.onCableSizeChange}>
					{sizes.map(size => {
						return <option value={size} key={size}>{size}</option>
					})}
				</select>
				<span className={styles.cableSizeMmLable2}>мм</span>

				<Button x="20" y="344" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="344" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксесуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '205px', top: "411px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					// onDoubleClick={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ПРАЙМЕР
 */
class FilterModeCablePrimer extends React.Component {
	render() {

		const sizes = Helper.cableGetFilterValuesBySeries(this.props.app.db.list, 'primer', 'size');

		SortUtils.sortSize(sizes);

		return (
			<div>

				<span className={styles.cableSizeLable}>Габариты:</span>

				<select className={styles.size} value={this.props.app.state.filterCableSize}
								onChange={this.props.app.onCableSizeChange}>
					{sizes.map(size => {
						return <option value={size} key={size}>{size}</option>
					})}
				</select>

				<span className={styles.cableSizeMmLable}>мм</span>

				<label className={styles.primerKindEui}>
					<input
						type="checkbox"
						name="pk"
						value={this.props.app.filterCablePrimerType}
						onChange={this.props.app.onCablePrimerTypeChange}
					/>
					ЭУИ
				</label>

				{this.props.app.state.filterCablePrimerType && this.props.app.state.filterCablePrimerType === 'eui' &&
				<div>
					<span className={styles.primerTypeLabel}>Тип ЭУИ:</span>
					<select className={styles.primerTypeSelect} value={this.props.app.state.filterCablePrimerEuiType}
									onChange={this.props.app.onCablePrimerEuiTypeChange}>
						<option value="Силовые">Силовые</option>
						<option value="Мультимедийные">Мультимедийные</option>
						<option value="Информационные">Информационные</option>
						<option value="Аксессуары для ЭУИ">Аксессуары для ЭУИ</option>
					</select>
				</div>
				}

				<Button x="20" y="368" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="368" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '185px', top: "432px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}

/**
 * ПРАЙМЕР рабочее место
 */
class FilterModeCablePrimerWorkplace extends React.Component {
	render() {

		const sizes = Helper.cableGetFilterValuesBySeries(this.props.app.db.list, 'primer', 'size');

		SortUtils.sortSize(sizes);

		return (
			<div>

				<span className={styles.cableSizeLable}>Тип:</span>
				<select className={styles.size}>
					<option value="Напольные системы">Напольные системы</option>
				</select>

				<span className={styles.cableSizeLable2}>Тип покрытия:</span>
				<select className={styles.size2} value={this.props.app.state.filterCablePrimerWorkplaceCoating}
								onChange={this.props.app.onCablePrimerWorkplaceCoatingChange}>
					<option value="бетон и технические полы">бетон и технические полы</option>
					<option value="пустотелые стены, полы и мебель">пустотелые стены, полы и мебель</option>
					<option value="бетоные полы и стены">бетоные полы и стены</option>
				</select>

				<span className={styles.cableSizeLable3}>Количество модулей:</span>
				<select className={styles.size3} value={this.props.app.state.filterCablePrimerWorkplaceModules}
								onChange={this.props.app.onCablePrimerWorkplaceModulesChange}>
					<option value="6">6</option>
					<option value="12">12</option>
					<option value="16">16</option>
				</select>

				<Button x="20" y="384" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={this.props.app.state.pickUpDisabled} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="384" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '186px', top: "432px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}

					itemInfo={this.props.app.state.item}
				/>

			</div>
		);
	}
}


/**
 * Фильтр трубы
 */
class FilterModePipe extends React.Component {
	render() {

		const pipeTypeList = [];
		const pipeDiameterList = [];
		const pipeColorList = [];

		this.props.app.db.kns_pipe.forEach(item => {

			if (this.props.app.state.filterOkl && ['Труба гофрированная ПНД', 'Труба гладкая жесткая ПНД'].indexOf(item.type) !== -1) {
				return;
			}

			if (pipeTypeList.indexOf(item.type) < 0) {
				pipeTypeList.push(item.type);
			}

			if (item.type === this.props.app.state.filterPipeType) {
				if (pipeDiameterList.indexOf(item.diameter) < 0) {
					pipeDiameterList.push(item.diameter);
				}

				if (String(item.diameter) === String(this.props.app.state.filterPipeDiameter) && pipeColorList.indexOf(item.color) < 0) {
					pipeColorList.push(item.color);
				}
			}
		});

		Helper.sortDiameter(pipeDiameterList);

		return (
			<div>

				<label className={styles.cableSeriesOkl}><input type="checkbox" checked={this.props.app.state.filterOkl}
																												onChange={this.props.app.onOklChange}/> Наличие сертификата
					"Огнестойкий"</label>

				<span className={styles.pipeTypeLable}>Тип:</span>
				<select className={styles.series} value={this.props.app.state.filterPipeType}
								onChange={this.props.app.onPipeTypeChange}>
					{pipeTypeList.map(type => {
						return <option value={type} key={type}>{type}</option>;
					})}
				</select>

				<span className={styles.cableSizeLable}>Диаметр:</span>
				<select className={styles.size} value={this.props.app.state.filterPipeDiameter}
								onChange={this.props.app.onPipeDiameterChange}>
					{pipeDiameterList.map(diameter => {
						return <option value={diameter} key={diameter}>{diameter}</option>;
					})}
				</select>
				<span className={styles.cableSizeMmLable}>мм</span>

				<span className={styles.pipeColorLable}>Цвет:</span>
				<select className={styles.pipeColor} value={this.props.app.state.filterPipeColor}
								onChange={this.props.app.onPipeColorChange}>
					{pipeColorList.map(color => {
						return <option value={color} key={color}>{color}</option>;
					})}
				</select>

				<label className={styles.pipeIp40}><input type="radio" name="ip" value="IP40"
																									onChange={this.props.app.onPipeIpChange}
																									defaultChecked={true}/>IP40</label>
				<label className={styles.pipeIp44}><input type="radio" name="ip" value="IP44"
																									onChange={this.props.app.onPipeIpChange}/>IP44</label>
				<label className={styles.pipeIp55}><input type="radio" name="ip" value="IP55"
																									onChange={this.props.app.onPipeIpChange}/>IP55</label>
				<label className={styles.pipeIp65}><input type="radio" name="ip" value="IP65"
																									onChange={this.props.app.onPipeIpChange}/>IP65</label>

				<Button x="20" y="380" buttonStyle={styles.pickUpBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCentered} text="Подобрать" onClick={this.props.app.onBtnPickUp}/>
				<Button x="220" y="380" buttonStyle={styles.cartBtn} iconStyle={styles.pickUpBtnIcon}
								textStyle={styles.mainBtnTextCenteredShort} buttonDisabledStyle={styles.pickUpBtnDisabled}
								disabled={!this.props.app.state.specList.length} text="В корзину" onClick={() => this.props.app.doAddToCart(this.props.app.specList)}/>

				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.props.app.state.itemList}
					styles={{width: '400px', height: '184px', top: "432px", left: '20px', fontSize: '12px'}}
					onSelect={this.props.app.onListItemCheck}
					addBasket={this.props.app.addBasket}
					itemInfo={this.props.app.state.item}
				/>

			</div>
		);

	}
}


class Helper {
	static sortDiameter(diameterList) {
		diameterList.sort((a, b) => {
			const ia = parseInt(a);
			const ib = parseInt(b);

			if (ia > ib) {
				return 1;
			}

			if (ia < ib) {
				return -1;
			}

			return 0;
		});
	}

	static cableGetFilterValuesBySeries(itemList, series, prop) {

		let sizes = [];

		for (let i = 0; i < itemList.length; i++) {
			const item = itemList[i];

			if (item.cable_series !== series) {
				continue;
			}

			if (item[prop] === 'Все' || item[prop] === 'all') {
				continue;
			}

			if (sizes.indexOf(item[prop]) >= 0) {
				continue;
			}

			sizes.push(item[prop]);
		}

		return sizes;
	}

}


export default KnsConfigurator;



// WEBPACK FOOTER //
// ./src/react/KnsConfigurator.jsx